module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./RegionManageView.js"));
	}, "RegionManageView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RegionManageView!./src/pages/Promote/Achievement/RegionManage/RegionManageView.js
// module id = 1135
// module chunks = 438